import { Spinner } from 'components/Elements';
import { WebLayout } from 'components/Layout';
import React, { useEffect } from 'react';

export const LenderPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <WebLayout>
      <div className="mx-24 mt-12">
        <div className="font-semibold text-3xl text-center">
          Finablr lender Policy/Agreement_February 2023
        </div>
      </div>
      <iframe
        src="https://docs.google.com/document/d/e/2PACX-1vSqfxPg0K831HueLKjKjA6IFBmcl3Ydz9w9ys9n-7yzKKQCU2P-2QGgmJ2wROqpL_UC0ss2RbF3uEZQ/pub?embedded=true"
        width="100%"
        height="800px"
        frameBorder="0"
        scrolling="yes"
        title="Finablr lender Policy/Agreement_February 2023"
        onLoad={<Spinner />}
      >
        <p>Your browser does not support iframes.</p>
      </iframe>
    </WebLayout>
  );
};
